'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();

import type { ComponentProps } from 'react'

import { useCalendly } from '@/components/integrations/calendly/calendly-provider'
import { Button, PlainButton } from '@/components/ui/button'
import { ChevronRightIcon } from '@heroicons/react/24/outline'

type CalendlyButtonProps = {
  label: string
  /** Stable slug of where this button lives, carried onto `demo_opened`. */
  location?: string
} & Pick<ComponentProps<typeof Button>, 'size' | 'color' | 'className'>

const withPointer = (className?: string) => (className ? `cursor-pointer ${className}` : 'cursor-pointer')

export function CalendlyButton({ label, size = 'lg', color = 'dark/light', className, location }: CalendlyButtonProps) {
  const { open, warmup } = useCalendly()

  return (
    <Button
      type="button"
      size={size}
      color={color}
      className={withPointer(className)}
      onClick={() => open({ location })}
      onPointerEnter={warmup}
      onFocus={warmup}
    >
      {label}
    </Button>
  )
}

type CalendlyPlainButtonProps = {
  label: string
  showChevron?: boolean
  /** Stable slug of where this button lives, carried onto `demo_opened`. */
  location?: string
} & Pick<ComponentProps<typeof PlainButton>, 'size' | 'color' | 'className'>

export function CalendlyPlainButton({
  label,
  size = 'lg',
  color = 'dark/light',
  className,
  showChevron = true,
  location,
}: CalendlyPlainButtonProps) {
  const { open, warmup } = useCalendly()

  return (
    <PlainButton
      type="button"
      size={size}
      color={color}
      className={withPointer(className)}
      onClick={() => open({ location })}
      onPointerEnter={warmup}
      onFocus={warmup}
    >
      {label}
      {showChevron ? <ChevronRightIcon className="size-4" /> : null}
    </PlainButton>
  )
}
